import React, { useRef } from "react";
import DynamicSimpleTable from "../../../util/DynamicSimpleReactTable";
import {
  errorMessage,
  formatDate,
  formatStatus,
  formatUsername,
} from "../../../util/Helpers";
import cogoToast from "cogo-toast";


export const SocialSubscriptionsTable = ({ details, row }) => {
  


  const tableRef = useRef();

  return (
    <DynamicSimpleTable
      key={"social-subscribers"}
      queryParams={`userId=${row?.userId || details?.userId}&product=social-power-user&limit=${10}`}
      searchBox={false} 
      source={{ url: `/subscriptions` }}
      columns={[
        { title: "PRODUCT", key: "product" },
        { title: "SUB KEY", key: "subKey" },
        { title: "FREQUENCY", key: "frequency" },
        { title: "AUTO RENEW", key: "autoRenew" },
        {
          title: "User",
          format: (row) =>
            formatUsername(
              row.modelRef,
              row.subscribedTo, 
              null,
              null,
              "subscriptions"
            ),
        },

        {
          title: "DUE DATE",
          format: (row) => formatDate(row.dueDate),
        },
        {
          title: "STATUS",
          format: (row) => formatStatus(row.status),
        },
        {
          title: "CREATED AT",
          format: (row) => formatDate(row.created),
        },
        {
          title: "UPDATED AT",
          format: (row) => formatDate(row.updated),
        },
      ]}
      ref={tableRef}
      onError={(err) => cogoToast.error(errorMessage(err))}
      refreshIcon={true}
    />
  );
};
